class PanelOverlayManager {
  constructor() {
    this.mapMenuButton = document.querySelector('[data-type="map-menu"]');
    this.hamburgerButton = document.querySelector('.voyager-header__hamburger-button');
    this.quickBookButton = document.querySelector('[data-type="quick-book"]');
    this.quickBookCloseButton = document.querySelector('.js-close-panel');
    this.siteHeader = document.querySelector('.voyager-header');
    this.mainPanel = document.querySelector('.js-main-panel');
    this.mapMenu = document.querySelector('.js-map-menu');
    this.mapMenuOverlay = document.querySelector('.js-map-menu-overlay');

    if (this.mapMenuButton && this.hamburgerButton && this.quickBookButton && this.siteHeader && this.mainPanel && this.mapMenu) {
      this.addEventListeners();
    }
  }

  addEventListeners() {
    this.mapMenuButton.addEventListener('click', this.handleMapMenuClick.bind(this));
    this.hamburgerButton.addEventListener('click', this.handleHamburgerClick.bind(this));
    this.quickBookButton.addEventListener('click', this.handleQuickBookClick.bind(this));
    this.quickBookCloseButton.addEventListener('click', this.handleMapMenuClick.bind(this));
  }

  handleMapMenuClick() {
    this.removeOtherClasses('map-menu');
  }

  handleHamburgerClick() {
    this.removeOtherClasses('hamburger');
  }

  handleQuickBookClick() {
    this.removeOtherClasses('quick-book');
    this.siteHeader.classList.add('quick-book-active');
  }

  removeOtherClasses(activeButton) {
    if (activeButton !== 'map-menu') {
      document.body.classList.remove('js-map-menu-visible');
      this.mapMenuButton.classList.remove('is-active');
      this.mapMenu.classList.remove('js-visible');
      this.mapMenu.classList.add('js-hidden');
      this.mapMenuOverlay.classList.remove('is-active');
      this.mapMenuOverlay.classList.add('js-hidden');
    }
    if (activeButton !== 'hamburger') {
      this.siteHeader.classList.remove('voyager-header__menu--visible');
      this.hamburgerButton.classList.remove('hamburger-button--is-active');
    }
    if (activeButton !== 'quick-book') {
      this.siteHeader.classList.remove('quick-book-active');
      this.mainPanel.classList.remove('js-visible');
      this.quickBookButton.classList.remove('is-active');
      this.siteHeader.classList.remove('quick-book-active');
    }
  }
}

// Initialize the class when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {
  new PanelOverlayManager();
});